import {ApiResponse} from "@models/axios";

export const enum FlagTag {
    NONE = 'none',
    HIDDEN = 'hidden',
    HAS_PAGE = 'has_page'
}

export interface Tag extends ApiResponse {
    id:string,
    short_id:string,
    title   : string,
    flag    : FlagTag  ,
    slug    : string
    cover_image_file : string | null,
    thumbnail_image_file_id : string | null,
    body: string,
    created_at: string,
    modified_at: string,
}



export interface TagsState {
    readonly loading: boolean
    readonly data: Tag[]
    readonly errors?: string
    readonly count:number
}
